import React from 'react';

const AuthLayout = ({ children }) => {
  return <div>{children}</div>; // Only render children (e.g., Login page)
};

export default AuthLayout;
